import { render, staticRenderFns } from "./BaseButtonSimple.vue?vue&type=template&id=08800542&scoped=true"
import script from "./BaseButtonSimple.vue?vue&type=script&lang=js"
export * from "./BaseButtonSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08800542",
  null
  
)

export default component.exports